// extracted by mini-css-extract-plugin
export default {"ctn":"dissipate_ctn__3MuKh","body":"dissipate_body__ZgEuH"};